/* istanbul ignore file */
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';

import { outageSlice } from './outage/outage.slice';
import { shipmentDetailsSlice } from './shipment/details/shipmentDetails.slice';
import { shipmentListSlice } from './shipment/list/shipmentList.slice';
import { analyticsSlice } from './analytics';
import { consignmentSwitcherSlice } from './consigmentSwitcher';
import { customerSlice } from './customer';
import { deliveryEstimateSlice } from './deliveryEstimate';
import { deliveryPreferenceSlice } from './deliveryPreference';
import { notificationSlice } from './notification';
import { selectRemoveSlice } from './selectRemove';
export const sliceReducers = {
  analytics: analyticsSlice.reducer,
  customer: customerSlice.reducer,
  notification: notificationSlice.reducer,
  deliveryEstimate: deliveryEstimateSlice.reducer,
  deliveryPreference: deliveryPreferenceSlice.reducer,
  consignmentSwitcher: consignmentSwitcherSlice.reducer,
  shipmentList: shipmentListSlice.reducer,
  shipmentDetails: shipmentDetailsSlice.reducer,
  selectRemove: selectRemoveSlice.reducer,
  outage: outageSlice.reducer,
};

export const configureStoreOptions = { reducer: sliceReducers };

export const store = configureStore(configureStoreOptions);

export type AppStore = typeof store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
